import { useEffect, useMemo, useState } from 'react';
import { useSupplierSearch } from '../../features/adminInventory/useSupplierSearch';
import useAdminInventoryStore from '../../store/useAdminInventoryStore';

const SupplierSelector = () => {
  const selectedSupplier = useAdminInventoryStore((state) => state.filters.supplier);
  const setSupplier = useAdminInventoryStore((state) => state.setSupplier);

  const [searchText, setSearchText] = useState(selectedSupplier?.full_name || '');
  const [debouncedQuery, setDebouncedQuery] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(searchText);
    }, 400);

    return () => clearTimeout(timer);
  }, [searchText]);

  useEffect(() => {
    if (selectedSupplier?.full_name) {
      setSearchText(selectedSupplier.full_name);
    }
  }, [selectedSupplier]);

  const { data = [], isLoading } = useSupplierSearch(debouncedQuery);

  const suppliers = useMemo(() => data || [], [data]);

  const handleSelect = (supplier) => {
    setSupplier(supplier);
    setSearchText(supplier.full_name);
    setOpen(false);
  };

  const handleClear = () => {
    setSupplier(null);
    setSearchText('');
    setOpen(false);
  };

  return (
    <div className="relative w-full">
      <label className="mb-1 block text-sm font-medium text-gray-700">
        تأمین کننده
      </label>

      <div className="relative">
        <input
          type="text"
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            setOpen(true);
            if (!e.target.value.trim()) {
              setSupplier(null);
            }
          }}
          onFocus={() => setOpen(true)}
          placeholder="جستجوی تأمین کننده..."
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-blue-500"
        />

        {selectedSupplier && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute left-2 top-1/2 -translate-y-1/2 text-xs text-red-500"
          >
            حذف
          </button>
        )}
      </div>

      {open && debouncedQuery?.trim() && (
        <div className="absolute z-20 mt-1 max-h-64 w-full overflow-auto rounded-lg border border-gray-200 bg-white shadow-lg">
          {isLoading ? (
            <div className="px-3 py-2 text-sm text-gray-500">در حال جستجو...</div>
          ) : suppliers.length > 0 ? (
            suppliers.map((supplier) => (
              <button
                key={supplier.id}
                type="button"
                onClick={() => handleSelect(supplier)}
                className="block w-full border-b border-gray-100 px-3 py-2 text-right hover:bg-gray-50"
              >
                <div className="text-sm font-medium text-gray-800">
                  {supplier.full_name}
                </div>
                <div className="text-xs text-gray-500">
                  {supplier.phone_number}
                </div>
              </button>
            ))
          ) : (
            <div className="px-3 py-2 text-sm text-gray-500">
              نتیجه‌ای یافت نشد
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SupplierSelector;
